import { render, staticRenderFns } from "./DialogLectureCode.vue?vue&type=template&id=650df546&"
import script from "./DialogLectureCode.vue?vue&type=script&lang=js&"
export * from "./DialogLectureCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports